<div>
    <hub-modal-header headerText="{{ 'bikeshop.workshop.jobcard.customer.add_a_customer' | translate }}"
        [activeModal]="activeModal"></hub-modal-header>
</div>

<div class="modal-content-container">

    <div class="row">
        <div class="col-12">
            <hub-input (ngModelChange)="onSearchChange($event)" [(ngModel)]="searchTerm" [iconColor]="'#888888'"
                [icon]="'search'" [autofocus]="true"
                [allowClear]="true"
                placeholder="{{ 'bikeshop.workshop.jobcard.customer.customer_search' | translate}}"></hub-input>
        </div>
    </div>
    <div class="row error" *ngIf="emailSearchIncomplete">
        <div class="col-12">
            {{ 'bikeshop.workshop.jobcard.customer.email_search_message' | translate}}
        </div>
    </div>          
    <div class="row error" *ngIf="phoneSearchIncomplete">
        <div class="col-12">
            {{ 'bikeshop.workshop.jobcard.customer.phone_search_message' | translate}}
        </div>
    </div>          

    

    <div class="results-container">
        <div class="header">
            <div>{{results.length}} {{(results.length === 1 ? 'bikeshop.workshop.jobcard.quote.result' :
                'bikeshop.workshop.jobcard.quote.results') | translate }}
            </div>
            <div>
                <hub-button [text]="'bikeshop.workshop.jobcard.customer.create_new_customer' | translate"
                    [style]="'borderless-secondary'" [icon]="'plus'" [size]="'md'" (buttonClick)="createNewCustomer()">
                </hub-button>
            </div>
        </div>
        <div *ngIf="isloading"><app-workshop-jobcard-customer-search-skeleton-loader></app-workshop-jobcard-customer-search-skeleton-loader></div>
        <div class="search-results" *ngIf="results && results.length > 0 && !isloading">
            <div *ngFor="let customer of results" class="search-result-item" (click)="selectedCustomer($event, customer)">
                <div>
                    <div class="customer-name">{{customer.Name}} {{customer.Surname}}</div>
                    <div class="customer-details">
                        <span>{{customer.Email}}</span>
                        <span *ngIf="customer.Email && customer.PhoneNumber"
                            style="margin-left: 8px;margin-right:8px;">|</span>
                        <span>{{customer.PhoneNumber}}</span>
                        
                        <span *ngIf="customer.ServiceCount && customer.ServiceCount > 0"
                            style="margin-left: 8px;margin-right:8px;">|</span>
                        <span *ngIf="customer.ServiceCount && customer.ServiceCount > 0">{{ 'bikeshop.workshop.jobcard.customer.previous_services' | translate }} => {{customer.ServiceCount}}</span>
                        
                    </div>
                </div>
                <div class="action-buttons">
                    <!-- <hub-button [icon]="'plus-alt'"
                        [style]="'secondary'" [size]="'sm'" (buttonClick)="selectedCustomer(customer)">
                    </hub-button> -->
                    <div class="action-button">
                    <hub-button [icon]="'dots-vertical'"
                        [style]="'borderless'" [size]="'sm'" (buttonClick)="showOptions($event, customer)"></hub-button>
                        <div *ngIf="customer.showActions" class="line-actions-dropdown">
                        <div (click)="editCustomer($event, customer)">
                            <daz-icon [name]="'pencil'" [size]="'16px'" [color]="'#060931'"></daz-icon>
                            <span>{{ 'bikeshop.workshop.jobcard.customer.edit_customer_details' | translate }}</span>
                        </div>
                        <div (click)="removeCustomer($event, customer)">
                            <daz-icon [name]="'trash'" [size]="'16px'" [color]="'#060931'"></daz-icon>
                            <span>{{ 'bikeshop.workshop.jobcard.customer.remove_customer' | translate }}</span>
                        </div>
                    </div>
                    </div>
                </div>

            </div>
        </div>
    </div>

</div>
<div class="modal-footer-container">
    <div class="short-cut-container">
        <span><daz-icon [name]="'enter'" [size]="'18px'"
                [color]="'#6B728C'"></daz-icon></span>{{'bikeshop.workshop.jobcard.quote.to_add_customer' |
        translate}}
    </div>
</div>